var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrending(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "512.000000pt",
    height: "512.000000pt",
    viewBox: "0 0 512.000000 512.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,512.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2518 4696 c-39 -20 -280 -206 -433 -332 -176 -146 -539 -511 -663 -666 -268 -337 -450 -685 -537 -1027 -39 -156 -56 -276 -62 -451 -13 -388 83 -724 296 -1041 521 -774 1559 -999 2356 -509 392 240 687 658 785 1108 62 288 46 546 -55 849 -67 203 -207 457 -329 598 -43 50 -51 55 -87 55 -31 0 -47 -7 -70 -29 l-29 -30 6 -188 c5 -150 3 -205 -9 -270 -24 -124 -31 -130 -51 -37 -83 384 -317 1218 -372 1325 -20 39 -65 55 -115 40 -50 -15 -61 -32 -103 -171 -69 -229 -183 -478 -284 -620 -57 -80 -160 -190 -179 -190 -31 0 -95 182 -108 305 -19 171 55 690 145 1018 54 195 52 230 -10 262 -36 19 -57 19 -92 1z m-167 -503 c-58 -270 -86 -543 -79 -768 5 -122 9 -151 35 -227 36 -106 95 -207 160 -276 44 -46 54 -52 90 -52 33 0 57 10 116 50 166 111 347 363 458 635 18 44 36 84 40 89 15 17 145 -430 208 -714 22 -102 54 -270 71 -375 17 -104 33 -204 35 -222 6 -32 39 -67 76 -78 37 -12 88 15 146 80 106 115 164 239 187 394 l12 84 41 -89 c108 -232 159 -482 142 -692 -43 -541 -359 -1011 -843 -1254 -246 -124 -513 -176 -799 -157 -612 41 -1148 458 -1342 1043 -142 427 -93 915 141 1385 199 404 538 802 1018 1200 60 50 111 89 114 87 2 -2 -10 -66 -27 -143z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrending);
export default __webpack_public_path__ + "static/media/trending.b0f92894d64cb3b511661a352567fef8.svg";
export { ForwardRef as ReactComponent };